import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const LS_KEY = 'arpflow.sidebar.collapsed';

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(LS_KEY) === '1');
  useEffect(() => { localStorage.setItem(LS_KEY, collapsed ? '1' : '0'); }, [collapsed]);
  return <div className="shell">
    <Sidebar collapsed={collapsed} canToggle onToggle={() => setCollapsed(value => !value)} />
    <main className="shell-content"><Outlet /></main>
  </div>;
}
